import numeral from 'numeral';

export default {
  install: (app) => {
    app.config.globalProperties.$numeral = numeral;
  },
};
